<form
  name="form"
  (ngSubmit)="f.form.valid && processData()"
  #f="ngForm"
  novalidate
>
  <!--CATAGORY SELECTION-->
  <div class="row">
    <!-- TYPE -->
    <div class="col-md-6">
      <div class="form-group padding-right-10">
        <mat-form-field>
          <mat-select
            placeholder="Type"
            [(ngModel)]="articleData.type"
            name="type"
            #type="ngModel"
            (selectionChange)="onTypeChange($event)"
            required
          >
            <mat-option *ngFor="let type of typeList" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <!-- Title -->
        <mat-form-field>
          <input
            matInput
            placeholder="Title"
            [(ngModel)]="articleData.title"
            name="title"
            #title="ngModel"
            required
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <!--YEAR AND MONTH SELECTION-->
  <div class="row" *ngIf="enableCeoSpecificFields">
      <div class="col-md-6">
        <div class="form-group padding-right-10">
          <mat-form-field>
              <mat-select
                  disableOptionCentering
                  placeholder="Year"
                  [(ngModel)]="articleData.year"
                  name="year"
                  #year="ngModel"
                  required
              >
                  <mat-option
                      *ngFor="let year of yearList"
                      [value]="year.year"
                  >
                      {{ year.year }}
                  </mat-option>
              </mat-select>
          </mat-form-field>
      </div>
      </div>
      <div class="col-md-6">
        <div
                    class="form-group">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Month"
                            [(ngModel)]="articleData.month"
                            name="month"
                            #month="ngModel"
                            required
                        >
                            <mat-option
                                *ngFor="let month of monthList"
                                [value]="month.month"
                            >
                                {{ month.month }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
      </div>
  </div>
  <!---RADIO SELECT-->
  <div class="form-group" *ngIf="!articleData?.id">
    <div>
      <label class="margin-bottom-15">Select Content</label>
    </div>
    <mat-radio-group
      name="contentType"
      [(ngModel)]="selectedContentType"
      (change)="file = null"
    >
      <mat-radio-button
        *ngFor="let cType of availableContentTypes"
        [value]="cType.value"
        [disabled]="cType?.disabled"
        [checked]="cType.value === selectedContentType"
      >
        {{ cType.name }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <!-- IMAGE UPLOAD -->
  <div *ngIf="selectedContentType === 'IMAGE'" class="row">
    <div class="col-md-12">
      <div class="form-group padding-right-10">
        <app-file-input
          *ngIf="!articleData.imagePath"
          (fileChange)="onFileChange($event)"
          [(ngModel)]="fileName"
          name="fileName"
          placeholder="Upload Image"
        >
          <button type="button" mat-raised-button color="primary">
            Choose
          </button>
        </app-file-input>
        <ng-template [ngIf]="articleData.imagePath">
          <mat-form-field>
            <input
              disabled
              matInput
              placeholder="Image"
              [(ngModel)]="articleData.imagePath"
              name="Image"
            />
            <button
              class="margin-right-30"
              mat-button
              matSuffix
              mat-icon-button
              type="button"
              (click)="articleData.imagePath = ''"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- PDF UPLOAD -->
  <div *ngIf="selectedContentType === 'PDF'" class="row">
    <div class="col-md-12">
      <div class="form-group padding-right-10">
        <app-file-input
          *ngIf="!articleData.pdfUrl"
          (fileChange)="onFileChange($event)"
          [(ngModel)]="fileName"
          name="fileName"
          placeholder="Upload PDF"
        >
          <button type="button" mat-raised-button color="primary">
            Choose
          </button>
        </app-file-input>
        <ng-template [ngIf]="articleData.pdfUrl">
          <mat-form-field>
            <input
              disabled
              matInput
              placeholder="pdf"
              [(ngModel)]="articleData.pdfUrl"
              name="Image"
            />
            <button
              class="margin-right-30"
              mat-button
              matSuffix
              mat-icon-button
              type="button"
              (click)="articleData.pdfUrl = ''"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- VEDIO/LINK UPLOAD -->
  <div *ngIf="selectedContentType === 'VIDEO'" class="row">
    <div class="col-md-12">
      <div class="form-group">
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Video url or Link"
            [(ngModel)]="articleData.video"
            name="url"
            #url="ngModel"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <!-- SHORT DESCRIPTION -->
  <div class="form-group" *ngIf="enableCeoSpecificFields">
    <mat-form-field>
        <textarea
            matInput
            placeholder="Short Description (Max. 80 Characters)"
            maxlength="80"
            [(ngModel)]="articleData.shortDesc"
            name="desc"
            #desc="ngModel"
            required
        ></textarea>
        <mat-error *ngIf="f.submitted && desc.invalid">Description is required</mat-error>
    </mat-form-field>
  </div>
  <!--- DESCRIPTION -->
  <div class="row" *ngIf="articleData.type === 'Media Interviews' || articleData.type === 'Latest News' || articleData.type === 'Message to Partners' || articleData.type === 'New Development'  || articleData.type === 'Article' || articleData.type === 'CEO Insights' || articleData.type === 'Videos'">
    <div class="col-md-12">
      <div class="form-group">
        <angular-editor
          [placeholder]
          [(ngModel)]="articleData.htmlContent"
          name="description"
          #description="ngModel"
          required
          [config]="editorConfig"
        ></angular-editor>
      </div>
    </div>
  </div>

  <div class="margin-top-20 text-center">
    <button
      mat-raised-button
      color="primary"
      class="mat-button-large"
      type="submit"
      [disabled]="!f.valid"
    >
      <span *ngIf="!articleData.id">Submit</span>
      <span *ngIf="articleData.id">Update</span>
    </button>
  </div>
</form>
